// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"218":"5e7eef2b","522":"e51649cb","905":"93165d42"}[chunkId] + ".chunk.js";
};